import { authAxios } from "services";

// eslint-disable-next-line import/prefer-default-export
export const fetchAll = () => authAxios().get(`/bannerPlaces`);

export const fetchOptions = () => authAxios().get(`/bannerPlaces/options`);
